import { ReactNode, useMemo, useState } from 'react';

import { IResolvedFaqCategory } from '@/src/utils/collections/faq/faq-categories.mappers';

export interface IFusyFaq {
  categorySlug: string;
  slug: string;
  text: ReactNode;
  content: string;
}

function extractTextFromReactNode(node: ReactNode): string {
  if (typeof node === 'string') {
    return node;
  }
  if (typeof node === 'number') {
    return node.toString();
  }
  if (Array.isArray(node)) {
    return node.map(extractTextFromReactNode).join(' ');
  }
  if (node && typeof node === 'object' && 'props' in node) {
    return extractTextFromReactNode(node.props.children);
  }
  return '';
}

function fuzzySearch(data: IResolvedFaqCategory[], searchTerm: string) {
  const parsedData: IFusyFaq[] = [];
  for (const item of data) {
    const categorySlug = item.slug;
    item.items?.map(faq => {
      parsedData.push({
        categorySlug: categorySlug,
        slug: faq.slug,
        text: faq.title,
        content:
          extractTextFromReactNode(faq.description) +
          ' ' +
          extractTextFromReactNode(faq.title),
      });
    });
  }

  return parsedData
    .map(item => {
      const isNameMatch = item.content.includes(searchTerm);

      return {
        ...item,
        isMatch: isNameMatch,
      };
    })
    .filter(item => item.isMatch);
}

export const useInputSearchFaq = (data?: IResolvedFaqCategory[]) => {
  const [search, setSearch] = useState('');
  const [focus, setFocus] = useState(false);

  const handleFocus = () => {
    setFocus(true);
  };

  const handleBlur = () => {
    setTimeout(() => {
      setFocus(false);
    }, 200);
  };

  const faqMemoized = useMemo(() => {
    if (data && search) {
      return fuzzySearch(data, search);
    }
    return [];
  }, [data, search]);

  return {
    search,
    setSearch,
    focus,
    faqMemoized,
    handleFocus,
    handleBlur,
  };
};
